import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-h5 text-center q-mb-xl" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_platform_icon = _resolveComponent("platform-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_password_input = _resolveComponent("password-input")!
  const _component_message = _resolveComponent("message")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_captcha = _resolveComponent("captcha")!
  const _component_multi_factor_auth = _resolveComponent("multi-factor-auth")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_platform_icon, { platform: _ctx.platform }, null, 8, ["platform"]),
      _createTextVNode(" Login to " + _toDisplayString(_ctx.platform), 1)
    ]),
    (!_ctx.captcha && !_ctx.mfa)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "q-gutter-y-md",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
        }, [
          _createVNode(_component_q_input, {
            label: "Email Address or Phone Number",
            modelValue: _ctx.credentials.id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.credentials.id) = $event)),
            outlined: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_password_input, {
            label: "Password",
            modelValue: _ctx.credentials.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.credentials.password) = $event)),
            outlined: ""
          }, null, 8, ["modelValue"]),
          (!_ctx.isLoading && _ctx.result && _ctx.result.error)
            ? (_openBlock(), _createBlock(_component_message, {
                key: 0,
                type: "negative",
                class: "q-mt-md"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.result.error), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_async_btn, {
              task: _ctx.task,
              label: "Login",
              type: "submit",
              color: "primary",
              class: "full-width",
              rounded: ""
            }, null, 8, ["task"])
          ])
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.result)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_captcha, {
            "session-id": _ctx.sessionId,
            result: _ctx.result,
            onResult: _cache[3] || (_cache[3] = ($event: any) => (_ctx.result = $event)),
            onError: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('error')))
          }, null, 8, ["session-id", "result"]),
          _createVNode(_component_multi_factor_auth, {
            "session-id": _ctx.sessionId,
            result: _ctx.result,
            onResult: _cache[5] || (_cache[5] = ($event: any) => (_ctx.result = $event)),
            onError: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('error')))
          }, null, 8, ["session-id", "result"])
        ]))
      : _createCommentVNode("", true)
  ]))
}